import { memo } from "react";
import { useTranslate } from "helpers/common";
import { initialDataWithPagination } from "services/api/consts";
import TableSearch from "ui/components/Table/TableSearch/TableSearch";
import { NOTIFICATION_ENTITY_SEARCH_COLUMNS, NOTIFICATION_SEARCH_COLUMNS } from "./consts";
import { NotificationSearchResultsProps } from "./types";
import NotificationEntityRowChild from "./components/NotificationEntityRowChild";

const NotificationSearchResults: React.FC<NotificationSearchResultsProps> = (props) => {
  const {
    searchResults,
    isLoading,
    onRowClick,
    onPaginationChange,
    onToggleActive,
    onDelete,
  } = props;

  const { t } = useTranslate();

  const columnsChild = NOTIFICATION_ENTITY_SEARCH_COLUMNS(t);

  return (
    <TableSearch
      data={searchResults.data}
      columns={NOTIFICATION_SEARCH_COLUMNS(t, onToggleActive, onDelete)}
      pagination={searchResults.pagination || initialDataWithPagination.pagination}
      onPaginationChange={onPaginationChange}
      onRowClick={onRowClick}
      isLoading={isLoading}
      selectableRows={false}
      columnsChild={columnsChild}
      CustomTableRowChild={NotificationEntityRowChild}
    />
  );
};

export default memo(NotificationSearchResults);
